import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { withRouter, useHistory } from "react-router-dom";

import styles from "./Edit.module.scss";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import PageHeader from "components/PageHeader/PageHeader";
import Container from "components/Container/Container";
import FormElement from "components/FormElement/FormElement";
import Select from "components/Select/Select";
import CostInput from "components/CostInput/CostInput";
import Row from "components/Row/Row";
import DateInput from "components/DateInput/DateInput";
import AddTask from "views/Achieve/Remediation/AddTask/AddTask";
import HR from "components/HR/HR";
import Button from "components/Button/Button";
import { toggleDropdowns } from "helpers/utils";
import {
    submitEditRemediationPlanFormAction,
    loadSitesAction,
    loadEditRemediationPlanFormAction,
    loadGapsAction,
    loadUsersByOrgAction,
    loadRolesAction,
} from "store/actions/Actions";

const Edit = (props) => {
    const remediationID = props.location.search.split("id=")[1];
    const history = useHistory();

    const [state, setState] = useState({
        title: '',
        site: '',
        status: '',
        associated_gap: '',
        estimated_cost: '',
        start_date: '',
        end_date: '',
        notes: '',
    });

    const [tasks, setTasks] = useState([]);
    const [stateErrors, setStateErrors] = useState({});

    const {
        loadEditRemediationPlanFormAction,
        UsersReducer,
        submitEditRemediationPlanFormAction,
        GapsReducer,
        loadUsersByOrgAction,
        loadGapsAction,
        SitesReducer,
        loadSitesAction,
        EditRemediationPlanFormReducer,
        UserOrgSiteReducer,
        UsersByOrgReducer,
        RolesReducer,
        loadRolesAction,
    } = props;

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!RolesReducer.roles) {
            loadRolesAction();
        }
    }, [RolesReducer.roles, loadRolesAction]);

    useEffect(() => {
        try {
            if (state.site !== "" && RolesReducer.roles) {
                loadUsersByOrgAction({
                    site: state.site,
                    department: undefined,
                    role: RolesReducer.roles.map((role) => !role.name.includes('User') ? Number(role.id) : '').filter(item => (typeof item === 'number')),
                });
            }
        } catch (error) {
            console.log('error', error);
        }
    }, [state.site, RolesReducer.roles]);

    useEffect(() => {
        if (!GapsReducer.gaps) {
            loadGapsAction();
        }
    }, [GapsReducer.gaps, loadGapsAction]);

    useEffect(() => {
        if (!EditRemediationPlanFormReducer.remediation_plans && UsersReducer.users) {
            loadEditRemediationPlanFormAction({ id: remediationID });
        } 
        
        if (EditRemediationPlanFormReducer.remediation_plans) {
            setState(s => ({
                ...s,
                ...EditRemediationPlanFormReducer.remediation_plans[0]
            }));
            if (EditRemediationPlanFormReducer.remediation_plans[0].tasks) {
                setTasks(s => (
                    EditRemediationPlanFormReducer.remediation_plans[0].tasks
                ));
            }
        }

    }, [EditRemediationPlanFormReducer.remediation_plans, loadEditRemediationPlanFormAction, remediationID, UsersReducer.users]);

    const handleChange = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: e.target.value
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const handleSelect = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]: (e.target.attributes && e.target.attributes.value) ? e.target.attributes.value.value : ''
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const submitRemediationPlan = (e) => {
        if (
            state.site === "" ||
            state.title === "" ||
            // state.associated_gap === "" ||
            state.start_date === "" ||
            state.end_date === ""
        ) {
            setStateErrors({
                ...stateErrors,
                site: state.site === "" ? "Site is required" : "",
                title: state.title === "" ? "Title is required" : "",
                // associated_gap: state.associated_gap === "" ? "Associated gap is required" : "",
                start_date: state.start_date === "" ? "Start date is required" : "",
                end_date: state.end_date === "" ? "End date is required" : "",
            });
        } else {
            e.preventDefault()
            submitEditRemediationPlanFormAction({ ...state, tasks });
        }
    };

    const gapsList = {};
    if (GapsReducer && GapsReducer.gaps) {
        GapsReducer.gaps.forEach((gap) => {
            gapsList[gap.id] = gap.name;
        });
    }

    let usersList = {};
    if (UsersByOrgReducer && UsersByOrgReducer.users) {
        UsersByOrgReducer.users.forEach((user) => {
            usersList[user.id || user.user_id] = user.name || user.email;
        });
    }

    const sitesList = {};
    SitesReducer && SitesReducer.sites && SitesReducer.sites.forEach(site => {
        sitesList[site.id] = site.name;
    })

    const statusCodes = {
        0: 'Pending',
        1: 'Incomplete',
        2: 'Complete',
    }

    // [OPTIONAL]
    // A way to close dropdowns when clicking on parent if they are open
    const statusDropdownRef = React.createRef()
    const associatedGapDropdownRef = React.createRef()
    const assigneeDropdownRef = React.createRef()
    const ownerDropdownRef = React.createRef()
    const siteRef = React.createRef();

    const is_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) || false;

    return (
        <AppLayoutWrapFull>
            <PageHeader />
            <Container>
                <form
                    className={styles.form}
                    onClick={toggleDropdowns([
                        statusDropdownRef,
                        associatedGapDropdownRef,
                        assigneeDropdownRef,
                        ownerDropdownRef,
                        siteRef
                    ])}
                >
                    <FormElement
                        labelText="TITLE"
                        htmlFor="title"
                        errorMessage={stateErrors.title}
                    >
                        <input
                            name="title"
                            type="text"
                            placeholder="Enter Plan Title"
                            value={state.title}
                            onChange={handleChange("title")}
                        />
                    </FormElement>
                    <FormElement
                        labelText="STATUS"
                        htmlFor="status"
                        errorMessage={stateErrors.status}
                    >
                        <Select
                            disabled={is_admin}
                            labels={statusCodes}
                            dropdownToggleRef={statusDropdownRef}
                            value={state.status || 0}
                            onClick={handleChange("status")}
                        >
                            <li value="0">Pending</li>
                            <li value="1">Incomplete</li>
                            <li value="2">Complete</li>
                        </Select>
                    </FormElement>
                    <FormElement
                        labelText="ASSOCIATED GAP"
                        htmlFor="associated_gap"
                        info={true}
                        errorMessage={stateErrors.associated_gap}
                    >
                        <Select
                            disabled
                            labels={gapsList}
                            placeholder="Select associated gap"
                            dropdownToggleRef={associatedGapDropdownRef}
                            value={state.associated_gap}
                            onClick={handleChange("associated_gap")}
                        >
                            {GapsReducer.gaps && GapsReducer.gaps.map((gap) => {
                                return <li key={gap.id} value={gap.id}>{gap.name}</li>;
                            })}
                        </Select>
                    </FormElement>
                    <FormElement
                        labelText="OWNER"
                        htmlFor="owner"
                        info={false}
                        errorMessage={stateErrors.owner}
                    >
                        <Select
                            placeholder="Select owner"
                            labels={usersList}
                            dropdownToggleRef={ownerDropdownRef}
                            value={state.owner}
                            onClick={handleChange("owner")}
                        >
                            {/* {UsersReducer && UsersReducer.users && UsersReducer.users.filter(item => item.registered === "t").map(user => <li key={user.email} data-name={user.name || user.email} value={user.id}>{user.name || user.email}</li>)} */}
                            {UsersByOrgReducer && UsersByOrgReducer.users && UsersByOrgReducer.users.filter(item => item.active === "t").map(user => <li key={user.email} data-name={user.name || user.email} value={user.id || user.user_id}>{user.name || user.email}</li>)}

                        </Select>
                    </FormElement>
                    <Row>
                        <FormElement
                            labelText="START DATE"
                            htmlFor="start_date"
                            errorMessage={stateErrors.start_date}
                        >
                            <DateInput
                                value={state.start_date}
                                onChange={handleChange("start_date")}
                            />
                        </FormElement>
                        <FormElement
                            labelText="END DATE"
                            htmlFor="end_date"
                            errorMessage={stateErrors.end_date}
                        >
                            <DateInput
                                value={state.end_date}
                                onChange={handleChange("end_date")}
                            />
                        </FormElement>
                    </Row>
                    <FormElement
                        labelText="SITE"
                        htmlFor="site"
                        errorMessage={stateErrors.site || ""}
                    >
                        <Select
                            labels={sitesList}
                            value={state.site}
                            placeholder="Select Site"
                            onClick={handleSelect("site")}
                            dropdownToggleRef={siteRef}
                        >
                            {SitesReducer.sites && SitesReducer.sites.map(site => <li key={`siteid-${site.id}`} data-name={site.name} value={site.id}>{site.name}</li>)}
                        </Select>
                    </FormElement>
                    <FormElement
                        labelText="ESTIMATED COST"
                        htmlFor="estimated_cost"
                        errorMessage={stateErrors.estimated_cost}
                    >
                        <CostInput
                            value={state.estimated_cost}
                            onChange={handleChange("estimated_cost")}
                        />
                    </FormElement>
                    <AddTask
                        allowAdd={true}
                        setParentErrors={setStateErrors}
                        className={styles["add-task"]}
                        tasks={tasks}
                        setTasks={setTasks}
                        dropdownToggleRef={assigneeDropdownRef}
                    />
                    <FormElement labelText="NOTES" htmlFor="notes">
                        <textarea
                            className={styles.notes}
                            value={state.notes}
                            onChange={handleChange("notes")}
                        />
                    </FormElement>
                    <HR className={styles["hr"]} />
                    <div className={styles["form-options"]}>
                        <Button text="CANCEL" color="secondary" onClick={() => history.push('/achieve/remediation')} />
                        <Button
                            text="SAVE"
                            icon="far fa-save"
                            onClick={submitRemediationPlan}
                        />
                    </div>
                </form>
            </Container>
        </AppLayoutWrapFull>
    )
}

const mapStateToProps = (state) => ({
    AddRemediationPlanFormReducer: state.AddRemediationPlanFormReducer,
    EditRemediationPlanFormReducer: state.EditRemediationPlanFormReducer,
    GapsReducer: state.GapsReducer,
    UsersReducer: state.UsersReducer,
    AuthReducer: state.AuthReducer,
    SitesReducer: state.SitesReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
    UsersByOrgReducer: state.UsersByOrgReducer,
    RolesReducer: state.RolesReducer,
});

const mapDispatchToProps = {
    submitEditRemediationPlanFormAction,
    loadGapsAction,
    loadUsersByOrgAction,
    loadSitesAction,
    loadRolesAction,
    loadEditRemediationPlanFormAction,
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Edit));
